import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, signal } from '@angular/core';
import { SharedLayoutContentWrapperComponent } from 'src/app/shared/components/layout/content-wrapper/content-wrapper.component';

@Component({
  selector: 'side-panel',
  templateUrl: './SidePanel.component.html',
  styleUrl: './SidePanel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    '[class.side-panel__collapsed]': 'collapsible() && collapsed()',
    '[class.side-panel__expanded]': 'expanded()',
    '[style.--side-panel-width]': 'widthStyle()',
    '[class.side-panel__custom]': '!contentWrapper',
  }
})
export class SidePanelComponent {
  readonly contentWrapper = inject(SharedLayoutContentWrapperComponent, { optional: true });

  readonly collapsible = input<boolean>(true);
  readonly collapsed = model(false);

  readonly canToggle = input(true);
  readonly expanded = computed(() => !this.collapsed());

  readonly width = input(285);
  readonly widthStyle = computed(() => `${this.width()}px`);

  constructor() {
    effect(() => {
      let collapsed = !this.expanded();
      let el = this.contentWrapper?.contentWrapperRef()?.nativeElement;
      if (el) {
        el.classList.toggle('side-panel-collapsed', collapsed);
      }
    });
  }
}
